<template>
  <img src="company_back.png" alt="Добавление компании"/>
</template>

<script>
export default {
  name: 'CompanyBack'
}
</script>
